import { translate } from '~l10n/client';

export type ItemsToMove = { name: string }[];

/**
 * Determine what title to display based upon the items being copied
 */
export function getCopyToWorkspaceDialogTitle(itemsToMove: ItemsToMove = []) {
  if (!itemsToMove.length) {
    return translate('Copy to…');
  }

  if (itemsToMove.length === 1) {
    return translate('Copy {0}').format(itemsToMove[0].name);
  }

  return translate('Copy {0} items').format(itemsToMove.length);
}
